import React, { Component } from 'react';

import PaginationComponent from './PaginationComponent';
import { sortClass, nextSortDir, sortAriaSort } from '../utils/table';
import { buildPaginationQuery, getPaginatedData, scheduleDebouncedCallback, clearDebouncedCallback } from '../utils/pagination';
import { getSelectedBranchId } from '../utils/branch';
import { hasActiveSearch, getSearchEmptyMessage } from '../utils/tableState';
import { navigateTo } from '../utils/navigation';

var config = process.env;

class CashRegisterListComponent extends Component {

    constructor() {
        super();
        this.state = {
            quantityShowRows: 25,
            currentPage: 1,
            totalItems: 0,
            search: '',
            searchInput: '',
            sortBy: 'day',
            sortDir: 'desc',
            // "Sin revisar": la cola de trabajo del control de caja.
            soloPendientes: false,
            data: [],
            loaded: false,
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    componentWillUnmount() {
        clearDebouncedCallback(this, 'searchDebounceTimeout');
    }

    fetchData = ({
        page = this.state.currentPage,
        limit = this.state.quantityShowRows,
        search = this.state.search,
        sortBy = this.state.sortBy,
        sortDir = this.state.sortDir,
        soloPendientes = this.state.soloPendientes,
        showLoader = true,
    } = {}) => {
        if (showLoader) {
            this.setState({ loaded: false });
        }
        const selectedBranchId = getSelectedBranchId();
        const query = buildPaginationQuery({
            page,
            limit,
            search,
            sortBy,
            sortDir,
            extraParams: {
                branchId: selectedBranchId || undefined,
                review: soloPendientes ? 'pending' : undefined,
            },
        });

        var request = {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        };

        // El historial se lee de las SESIONES, no de `cash_register`: esa tabla tiene PK
        // (día, usuario, sucursal), así que dos ciclos en el mismo día colapsan en una fila y se
        // mezclan — se veía una con el nombre de quien abrió la caja nueva y el de quien cerró la
        // anterior. El endpoint une las sesiones con las filas viejas, que siguen a la vista.
        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}cashSession/history?${query}`, request)
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                const paginatedData = getPaginatedData(data);
                this.setState({
                    data: paginatedData.items || [],
                    quantityShowRows: paginatedData.limit || Number(limit),
                    currentPage: paginatedData.page || Number(page),
                    totalItems: paginatedData.total || 0,
                    search,
                    sortBy,
                    sortDir,
                    soloPendientes,
                    loaded: true,
                });
            }
        });
    }

    renderEmptyState = () => {
        return (
            <div
                style={{
                    background: '#ffffff',
                    borderRadius: '0.625rem',
                    boxShadow: '0 .125rem .625rem rgba(90,97,105,.12)',
                    border: '1px solid #e1e5eb',
                    minHeight: '320px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2rem',
                }}
            >
                <div style={{ textAlign: 'center', maxWidth: '420px' }}>
                    <div
                        style={{
                            width: '72px',
                            height: '72px',
                            margin: '0 auto 1rem',
                            borderRadius: '50%',
                            background: '#f5f6f8',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <i className="material-icons" style={{ fontSize: '34px', color: '#818ea3' }}>point_of_sale</i>
                    </div>
                    <h4 style={{ marginBottom: '0.75rem', color: '#3d5170', fontWeight: 500 }}>
                        Todavia no hay movimientos de caja para mostrar
                    </h4>
                    <p style={{ margin: 0, color: '#818ea3', lineHeight: 1.6 }}>
                        Cuando registres movimientos de caja, aca vas a ver el historial de aperturas,
                        cierres, retiros y observaciones.
                    </p>
                </div>
            </div>
        );
    }

    renderLoader = () => {
        return (
            <div
                style={{
                    background: '#ffffff',
                    borderRadius: '0.625rem',
                    boxShadow: '0 .125rem .625rem rgba(90,97,105,.12)',
                    border: '1px solid #e1e5eb',
                    minHeight: '320px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2rem',
                }}
            >
                <div className="containerLoader" style={{ display: 'block', position: 'static', width: '100%' }}>
                    <div className="loader"></div>
                </div>
            </div>
        );
    }

    formatDay = (value) => {
        if (!value) {
            return '';
        }

        const normalizedValue = String(value).split('T')[0];
        const parts = normalizedValue.split('-');

        if (parts.length === 3) {
            const [year, month, day] = parts;
            return `${day}-${month}-${year}`;
        }

        return normalizedValue;
    }

    drawRow = (item, index) => {
        const date = this.formatDay(item.day);
        return (
            <tr role="row" className="odd" key={(item.id || 'legacy') + '-' + item.day + index} style={{ background: item.status == 0 ? (index % 2 == 0 ? '#ffffff;' : '#fcfcfc') : '#e5ffe5' }}>
                {/* El día lleva al control de esa caja. Las filas viejas (sin id, de
                    `cash_register`) no tienen detalle: son anteriores a la sesión de caja. */}
                <td tabIndex="0" className="sorting_1">
                    {item.id ? (
                        <button
                            type="button"
                            className="btn btn-link p-0"
                            style={{ fontSize: 'inherit', textAlign: 'left' }}
                            title="Ver el control de esta caja"
                            onClick={() => navigateTo(`/controlCaja?sesion=${item.id}`)}
                        >
                            {date}
                        </button>
                    ) : date}
                </td>
                {/* El nombre del responsable, no la cuenta: el login es compartido y decía
                    siempre lo mismo. Se cae a la cuenta en las filas viejas, que no lo tienen. */}
                <td>{item.opened_by_name || item.userDisplayName || item.user}</td>
                <td>{item.closed_by_name || '—'}</td>
                <td>{item.open_hour}</td>
                <td>{item.close_hour}</td>
                <td>{item.open_money}</td>
                <td>{item.close_money}</td>
                <td>{item.expected_money != null ? item.expected_money : '—'}</td>
                {/* La diferencia es LO que hay que mirar del historial: se pinta con color y
                    signo para que un faltante salte a la vista en vez de haber que restar. */}
                <td style={{
                    fontVariantNumeric: 'tabular-nums',
                    color: item.difference == null ? undefined
                        : (Math.abs(Number(item.difference)) < 1 ? '#2c7a5a'
                            : (Number(item.difference) > 0 ? '#8a6212' : '#a8402f')),
                    fontWeight: item.difference != null && Math.abs(Number(item.difference)) >= 1 ? 600 : undefined,
                }}>
                    {item.difference == null ? '—'
                        : (Number(item.difference) > 0 ? `+${item.difference}` : item.difference)}
                </td>


                <td>
                    {item.status == 0 ? 'CERRADA' : 'ABIERTA'}
                    {/* La revisión del admin en el control de caja. Va dentro del estado y no en
                        una columna propia: la grilla ya no tenía ancho para una más. */}
                    {item.id && Number(item.status) === 0 && (
                        <div style={{ fontSize: 12, fontWeight: 600, color: item.reviewed_at ? '#2c7a5a' : '#8a6212' }}>
                            {item.reviewed_at ? 'Revisada' : 'Sin revisar'}
                        </div>
                    )}
                </td>
                <td>{item.observations}</td>
            </tr>
        );
    }

    loadData = () => {
        if (!this.state.loaded) {
            return <tbody></tbody>;
        }

        return (
            <tbody>
                {this.state.data.length > 0 ? this.state.data.map((item, index) => this.drawRow(item, index)) : (
                    <tr key="empty">
                        <td colSpan="11" style={{ textAlign: 'center', padding: '10px', border: '1px solid rgb(225, 229, 235)' }}>
                            {this.state.soloPendientes && !(this.state.searchInput || this.state.search)
                                ? 'No hay cajas cerradas sin revisar.'
                                : getSearchEmptyMessage(this.state.searchInput || this.state.search)}
                        </td>
                    </tr>
                )}
            </tbody>
        );
    }

    onChangeShowRows = () => {
        const itemSelected = Number(document.getElementById('select_rows').value);
        this.fetchData({ page: 1, limit: itemSelected });
    }

    onChangeInput = (search) => {
        this.setState({ searchInput: search });
        scheduleDebouncedCallback(this, 'searchDebounceTimeout', () => {
            this.fetchData({ page: 1, search, showLoader: false });
        });
    }

    orderData = (column) => {
        this.fetchData({
            page: 1,
            sortBy: column,
            sortDir: nextSortDir(column, this.state.sortBy, this.state.sortDir),
        });
    }

    // Props de una cabecera ordenable: la clase y el aria-sort se derivan del state, así que
    // sobreviven al remonte que provoca el loader.
    sortableHeader = (column) => ({
        onClick: () => this.orderData(column),
        className: sortClass(column, this.state.sortBy, this.state.sortDir),
        'aria-sort': sortAriaSort(column, this.state.sortBy, this.state.sortDir),
        tabIndex: '0',
    })

    render() {
        if (!this.state.loaded) {
            return this.renderLoader();
        }

        if (this.state.totalItems === 0 && !this.state.soloPendientes && !hasActiveSearch(this.state.searchInput, this.state.search)) {
            return this.renderEmptyState();
        }

        return (
            <div>
                {/* Fuera de `.dataTables_filter`: el CSS del template esconde el texto de los
                    labels de esa barra (por eso "Search:" tampoco se ve). */}
                <div className="d-flex flex-wrap align-items-center justify-content-between mb-2" style={{ gap: 8, fontSize: 14 }}>
                    <span style={{ color: '#818ea3' }}>Tocá el día para ver el control de esa caja.</span>
                    <label className="mb-0" style={{ cursor: 'pointer', color: '#3d5170' }}>
                        <input
                            type="checkbox"
                            checked={this.state.soloPendientes}
                            onChange={(e) => this.fetchData({ page: 1, soloPendientes: e.target.checked })}
                            style={{ marginRight: 6 }}
                        />
                        Sólo las cerradas sin revisar
                    </label>
                </div>
                <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                    <div className="dataTables_length" id="DataTables_Table_0_length">
                        <label>Show
                        <select id="select_rows" name="DataTables_Table_0_length" aria-controls="DataTables_Table_0" value={this.state.quantityShowRows} onChange={() => this.onChangeShowRows()}>
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                        entries</label>
                    </div>
                    <div id="DataTables_Table_0_filter" className="dataTables_filter">
                        <label>Search:
                        <input id="input_search" type="search" className="" placeholder="" aria-controls="DataTables_Table_0" value={this.state.searchInput} onChange={(e) => this.onChangeInput(e.target.value)}/>
                        </label>
                    </div>

                    <table className="transaction-history d-none dataTable no-footer dtr-inline" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                        <thead>
                            <tr role="row">
                                <th {...this.sortableHeader('day')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Dia</th>
                                <th {...this.sortableHeader('opened_by_name')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Abrió</th>
                                <th {...this.sortableHeader('closed_by_name')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Cerró</th>
                                <th {...this.sortableHeader('open_hour')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Apertura</th>
                                <th {...this.sortableHeader('close_hour')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Cierre</th>
                                <th {...this.sortableHeader('open_money')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '5%' }}>Dinero apertura</th>
                                <th {...this.sortableHeader('close_money')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '5%' }}>Dinero Cierre</th>
                                <th {...this.sortableHeader('expected_money')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '5%' }}>Esperado</th>
                                <th {...this.sortableHeader('difference')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '5%' }}>Diferencia</th>


                                <th {...this.sortableHeader('status')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Estado</th>
                                <th {...this.sortableHeader('observations')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '25%' }}>Observaciones</th>
                            </tr>
                        </thead>
                        {this.loadData()}
                    </table>
                    <PaginationComponent
                        totalItems={this.state.totalItems}
                        quantityRows={this.state.quantityShowRows}
                        currentPage={this.state.currentPage}
                        onPageChange={(page) => this.fetchData({ page })}
                    />
                </div>
            </div>
        );
    }
}

export default CashRegisterListComponent;
